import { Component } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'hs-position-exchange-error',
  templateUrl: './position-exchange-error.component.html',
  styleUrls: ['./position-exchange-error.component.css'],
})
export class PositionExchangeErrorComponent {
  constructor(public activeModal: NgbActiveModal) {}
}
